const my_profile = {
  viewMyClubSeacretProfile: "Peržiūrėti mano ClubSeacret profilį", // translated
  viewMoreDetails: "Žiūrėti daugiau informacijos", // translated
  verifiedEmail: "Patvirtintas el", // translated
  unverifiedEmail: "Nepatvirtintas el", // translated
  balance: "Balansas", // translated
  pointsIn: "Taškai į", // translated
  pointsOut: "Atkreipia dėmesį į", // translated
  topUp: "Prisipilti", // translated
  pointsHistoryTable: "Taškų istorijos lentelė", // translated
  createdFrom: "Sukurta nuo", // translated
  createdTo: "Sukurtas iki", // translated
  selectStatus: "Pasirinkite būseną...", // translated
  searchByTitle: "Ieškoti pagal pavadinimą...", // translated
  pushNotifications: "Push pranešimai",
  pushNotificationsDescription: "Gaukite naršyklės pranešimus apie svarbius atnaujinimus ir įvykius",
  pushNotificationsNotSupported: "Push pranešimai šioje naršyklėje nepalaikomi",
  pushNotificationsDeniedMessage: "Pranešimų leidimas buvo atmestas. Prašome įjungti pranešimus naršyklės nustatymuose, kad gautumėte push pranešimus.",
  pushNotificationsEnabled: "Push pranešimai sėkmingai įjungti",
  pushNotificationsDisabled: "Push pranešimai sėkmingai išjungti",
  userInformationMissing: "Trūksta vartotojo informacijos",
  failedToUpdatePushNotifications: "Nepavyko atnaujinti push pranešimų nustatymų",
  notificationPermissionDenied: "Pranešimų leidimas buvo atmestas. Prašome jį įjungti naršyklės nustatymuose.",
  notificationPermissionRequired: "Reikalingas pranešimų leidimas, kad būtų įjungti push pranešimai",
  notSupported: "Nepalaikoma",
  permissionDenied: "Leidimas atmestas",
  permissionNotRequested: "Leidimas neprašytas",
  enabled: "Įjungta",
  disabled: "Išjungta",
};

export default my_profile;
